import styled from 'styled-components';

const ColorRange = styled.div`
  white-space: nowrap;
  position: relative;
  top: 4px;
`;

const GradStep = styled.span`
  height: ${props => props.height};
  width: 1%;
  background-color: ${props => props.color};
`;

export default {
  ColorRange,
  GradStep
};
